import React from 'react';
import { CHARACTERS_PER_PAGE } from '../config';
import { ReactComponent as FirstPage } from '../assets/svgs/first-page.svg';
import { ReactComponent as LastPage } from '../assets/svgs/last-page.svg';
import { ReactComponent as NextPage } from '../assets/svgs/next-page.svg';
import { ReactComponent as PrevPage } from '../assets/svgs/prev-page.svg';

const PageControls = ({ page, handlePageChange, pageContent }) => {
    const isCurrentPageFirst = page === 1;
    const contentLength = Object.keys(pageContent).length;
    const isLastPage = page * CHARACTERS_PER_PAGE >= contentLength;
    const totalPages = Math.ceil(contentLength / CHARACTERS_PER_PAGE);

    return (
        <>
            {contentLength > CHARACTERS_PER_PAGE ? (
                <div className="pagination-controls">
                    <FirstPage className={`page-button ${isCurrentPageFirst ? 'disabled' : ''}`} onClick={() => handlePageChange(1)} />
                    <PrevPage className={`page-button ${isCurrentPageFirst ? 'disabled' : ''}`} onClick={() => handlePageChange(Math.max(page - 1, 1))} />
                    <span>{page}</span>
                    <NextPage className={`page-button ${isLastPage ? 'disabled' : ''}`} onClick={() => handlePageChange(Math.min(page + 1, totalPages))} />
                    <LastPage className={`page-button ${isLastPage ? 'disabled' : ''}`} onClick={() => handlePageChange(totalPages)} />
                </div>
            ) : (
                <div></div>
            )}
        </>
    );
};

export default PageControls;